module.exports = __webpack_public_path__ + "img/arrow-pink.3971c658.png";